import type { SVGProps } from 'react';
const SvgAlertCircleStreamlineCoreLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
    <desc>{'Alert Circle Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 13.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M7 3.75v3.5" />
      <path d="M7 10h.01" />
    </g>
  </svg>
);
export default SvgAlertCircleStreamlineCoreLine;
